import PropTypes from 'prop-types';

var propTypes = {
    className: PropTypes.string,
    errorCode: PropTypes.string.isRequired,
    errorMessage: PropTypes.string,
    'data-testid': PropTypes.string,
    title: PropTypes.string,
    ctaContent: PropTypes.elementType,
    shouldDisplayLogo: PropTypes.bool,
};
var defaultProps = {
    errorCode: '404',
    title: 'Oops!',
    shouldDisplayLogo: true,
    'data-testid': 'spoton-error-page',
};

export { defaultProps, propTypes };
